/**
 * Presentation-only readers for existing service.pricing.callOutFee fields.
 * Missing, null, or undefined amounts stay null so the UI can omit the ₹ line.
 * This does not invent defaults and does not change payment math.
 */

const URGENCY_FEE_KEY = {
  emergency: 'immediate',
  '24h': 'sameDay',
  '48h': 'within48Hours',
};

function finiteAmount(raw) {
  if (raw === null || raw === undefined || raw === '') return null;
  const amount = typeof raw === 'number' ? raw : Number(raw);
  // Zero and negative are not a fee digit. Omit the ₹ line rather than invent one.
  if (!Number.isFinite(amount) || amount <= 0) return null;
  return amount;
}

export function callOutAmountForUrgency(callOutFee, urgency) {
  if (!callOutFee || typeof callOutFee !== 'object') return null;
  const key = URGENCY_FEE_KEY[urgency];
  if (!key || !Object.prototype.hasOwnProperty.call(callOutFee, key)) return null;
  return finiteAmount(callOutFee[key]);
}

/**
 * Digit for a strip that is not tied to one chosen service.
 * Returns a number only when every loaded service has that same finite fee.
 * Any missing field or disagreement returns null (omit the ₹ line).
 */
export function unanimousCallOutAmount(services, urgency) {
  if (!Array.isArray(services) || services.length === 0) return null;
  let agreed;
  for (const service of services) {
    const amount = callOutAmountForUrgency(service?.pricing?.callOutFee, urgency);
    if (amount === null) return null;
    if (agreed === undefined) agreed = amount;
    else if (agreed !== amount) return null;
  }
  return agreed === undefined ? null : agreed;
}

/** Same service resolution the booking form already uses for the live fee. */
export function resolveBookingCallOutFee(currentService, services, serviceId) {
  let service = currentService;
  if (!service?.pricing?.callOutFee && serviceId && Array.isArray(services) && services.length > 0) {
    const match = services.find((item) => item._id === serviceId);
    if (match) service = match;
  }
  return service?.pricing?.callOutFee || null;
}
